import src from "IMAGE";
export default { src, width: 1024, height: 558, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAQAAAAZxLZ7AAAASUlEQVR42h3IvQ1FYABA0W/NM8YrHgoDsAIDSHRExAaCPSQaPxMgcpubE34irclskPoLscrocFrUEiHTWN1vm14uFDr7B9d7pQdoeiJmF+J6+QAAAABJRU5ErkJggg=="};
